var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { Button } from '@mui/material';
export default function SidebarCopyPaste({ href, children }) {
    const handleCopy = () => __awaiter(this, void 0, void 0, function* () {
        try {
            yield navigator.clipboard.writeText(children);
            alert('Text copied to clipboard!');
        }
        catch (err) {
            console.error('Failed to copy text: ', err);
        }
    });
    return (React.createElement(Button, { size: "small", href: href, onClick: handleCopy }, children));
}
//# sourceMappingURL=SidebarCopyPaste.js.map